import React from 'react';

const ShimmerBox = ({ className = '', style = {} }) => (
  <div
    className={`rounded-lg ${className}`}
    style={{
      background: 'linear-gradient(90deg, rgba(0,212,255,0.04) 25%, rgba(0,212,255,0.1) 50%, rgba(0,212,255,0.04) 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
      ...style
    }}
  />
);

const ComparisonColumnSkeleton = () => (
  <div className="px-4 py-3 min-w-56">
    {/* Property image skeleton */}
    <ShimmerBox className="w-full h-32 mb-3" />
    {/* Address lines */}
    <ShimmerBox className="h-4 w-4/5 mb-2" />
    <ShimmerBox className="h-3 w-3/5 mb-3" />
    {/* View button */}
    <ShimmerBox className="h-7 w-full" />
  </div>
);

const ComparisonRowSkeleton = ({ isEven }) => (
  <tr style={{ background: isEven ? '#0A1628' : '#0D1B2A' }}>
    {/* Label cell */}
    <td
      className="px-4 py-3 sticky left-0 z-10 w-40"
      style={{ background: isEven ? '#0A1628' : '#0D1B2A', borderBottom: '1px solid rgba(0, 212, 255, 0.06)' }}
    >
      <ShimmerBox className="h-4 w-24" />
    </td>
    {/* Value cells */}
    {[0, 1, 2]?.map(i => (
      <td key={i} className="px-4 py-3" style={{ borderBottom: '1px solid rgba(0, 212, 255, 0.06)' }}>
        <ShimmerBox className="h-4 w-3/4" />
      </td>
    ))}
  </tr>
);

const ComparisonTableSkeleton = () => (
  <div
    className="rounded-2xl overflow-hidden"
    style={{ border: '1px solid rgba(0, 212, 255, 0.15)' }}
  >
    <div className="overflow-x-auto">
      <table className="w-full min-w-max border-collapse">
        <thead>
          <tr>
            <th
              className="text-left px-4 py-3 w-40 sticky left-0 z-20"
              style={{ background: '#0A1628', borderBottom: '1px solid rgba(0, 212, 255, 0.15)' }}
            >
              <ShimmerBox className="h-4 w-16" />
            </th>
            {[0, 1, 2]?.map(i => (
              <th
                key={i}
                className="px-4 py-3 min-w-56"
                style={{ borderBottom: '1px solid rgba(0, 212, 255, 0.15)', background: '#0D1B2A' }}
              >
                <ComparisonColumnSkeleton />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2, 3, 4, 5, 6]?.map(i => (
            <ComparisonRowSkeleton key={i} isEven={i % 2 === 0} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const MobileComparisonSkeleton = () => (
  <div>
    {/* Tab selector skeleton */}
    <div className="flex gap-2 pb-2 mb-4">
      {[0, 1, 2]?.map(i => (
        <ShimmerBox
          key={i}
          className="flex-shrink-0 h-9 w-28 rounded-xl"
        />
      ))}
    </div>
    {/* Card skeleton */}
    <div
      className="rounded-2xl overflow-hidden"
      style={{ border: '1px solid rgba(0, 212, 255, 0.15)' }}
    >
      {/* Image */}
      <ShimmerBox className="w-full h-48 rounded-none" />
      {/* Details */}
      <div className="p-4" style={{ background: '#0D1B2A' }}>
        <ShimmerBox className="h-5 w-3/4 mb-2" />
        <ShimmerBox className="h-4 w-1/2 mb-3" />
        <ShimmerBox className="h-8 w-2/5 mb-4" />
        {/* Stats grid */}
        <div className="grid grid-cols-4 gap-2 mb-4">
          {[0, 1, 2, 3]?.map(i => (
            <ShimmerBox key={i} className="h-16 rounded-xl" />
          ))}
        </div>
        <ShimmerBox className="h-10 w-full rounded-xl" />
      </div>
    </div>
  </div>
);

export { ComparisonTableSkeleton, MobileComparisonSkeleton };
export default ComparisonTableSkeleton;
